/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckLoginAppRequestApiRoaming } from '../../models/check-login-app-request-api-roaming';

export interface ApiRoamingCheckloginappPost$Params {

/**
 * Request language.
 */
  lang?: string;
  
    /**
     * Login verification data.
     */
    body?: CheckLoginAppRequestApiRoaming
}

export function apiRoamingCheckloginappPost(http: HttpClient, rootUrl: string, params?: ApiRoamingCheckloginappPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingCheckloginappPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiRoamingCheckloginappPost.PATH = '/api/Roaming/checkloginapp';
